export default "__VITE_ASSET__FYF4g2rn__"